const searchClick = function (e) {
    const parent = document.querySelector('.search-container');
    const searchText = parent.querySelector('.search-container__input');

    if (!(parent.classList.contains('search-container--active') && searchText.value.length > 0)) {
        e.preventDefault();
        parent.classList.toggle('search-container--active');
        if (parent.classList.contains('search-container--active')) {
            searchText.focus();
            let len = searchText.value.length * 2;
            searchText.setSelectionRange(len, len);
        } else {
            parent.focus();
        }
    }
};

export default function initializeSearchForm() {
    if (document.querySelector('.search-container__button')) {
        document.querySelector('.search-container__button').addEventListener('click', searchClick);
    }

    if (document.querySelector('body').classList.contains('search')) {
        document.querySelector('.search-container').classList.add('search-container--active');
    }
}
